
const CardDashboards = ({
  title,
  buttonToBack,
  handleGoToback,
  buttonToEdit,
  handleGoToEdit,
  titlePosition,
  titlePadding,
  backgroundColor,
  titleColor,
  lineUnderTitle,
  footerContent,
  children,
  buttomSearch,
  handleSearchChange,
  handleSearchClear,
  selectOptions,
  handleSelectChange,
  scroll,
  searchHeader
}: propsCard) => {
  return (
    <>
      <div className="card-body" style={{ width: '100%', overflow: scroll ? 'auto' : 'unset' }}>{children}</div>
      <div style={{ width: '100%', display: 'flex', justifyContent: 'end' }}>{footerContent}</div>
    </>
  )
};
export default CardDashboards;
